import styled from "styled-components";

export const _ScrollProgressBarRoot = styled.div<{ $hidden?: boolean }>(
  ({ $hidden }) => ({
    display: $hidden ? "none" : "flex",
    justifyContent: "center",
    width: "100%",
    marginTop: 32,
    marginBottom: 32,
  })
);

const PROGRESS_BAR_HEIGHT = 6;
const PROGRESS_BAR_RADIUS = PROGRESS_BAR_HEIGHT / 2;

export const _ScrollProgressBarTrack = styled.div(() => ({
  width: 280,
  height: PROGRESS_BAR_HEIGHT,
  background: "#F4F3F1",
  borderRadius: PROGRESS_BAR_RADIUS,
  overflow: "hidden",
}));

export const _ScrollProgressBarFill = styled.div<{ $progress: number }>(
  ({ $progress }) => ({
    height: "100%",
    width: `${Math.min(1, Math.max(0, $progress)) * 100}%`,
    background: "#6C6C6C",
    borderRadius: PROGRESS_BAR_RADIUS,
  })
);
